module.exports = __webpack_public_path__ + "static/media/AntDesign.3a2ba315.ttf";